import { api } from "@api/api";
import { Company } from "@modules/companies/types";
import { CompanyFormValues } from "@modules/companies/validations";

export async function createCompanyService(data: CompanyFormValues): Promise<Company> {
  const { logo, cover_photo, ...body } = data;

  const { data: company } = await api.post<Company>("v1/company_admin/", body);

  if (logo && logo instanceof File || cover_photo && cover_photo instanceof File) {
    const formData = new FormData();
    formData.append("logo", logo);
    formData.append("cover_photo", cover_photo);

    await api.patch(`v1/company_admin/${company.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return company;
}
